<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="600"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>edit</v-icon> Modificar registro 
				</v-flex>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<!-- Cuerpo del formulario -->
			<v-form
				@submit.prevent="save"
				v-model="valid"
				ref="form"
				lazy-validation
				>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex md12>
								<p><strong>Fecha: </strong>{{form.fecha}} </p>
							</v-flex> 
						</v-layout>
						<v-layout wrap>
							<v-flex md6>
								<v-text-field
									type="time"
									v-model="form.ingreso_am"
									label="Hora ingreso mañana"
									
									/>
							</v-flex> 
							<v-flex md6>
								<v-text-field
									type="time"
									v-model="form.salida_am"
									label="Hora salida mañana"
									
									/>
							</v-flex> 
						</v-layout>

						<v-layout wrap>
							<v-flex md6>
								<v-text-field
									type="time"
									v-model="form.ingreso_pm"
									label="Hora ingreso tarde"
									
									/>
							</v-flex> 
							<v-flex md6>
								<v-text-field
									type="time"
									v-model="form.salida_pm"
									label="Hora salida mañana"
									
									/>
							</v-flex> 
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					
					<v-btn
						@click.native="close()">
						<v-icon>cancel</v-icon> {{$t('common.cancel') }}
					</v-btn>
					<v-btn
						color="primary"
						type="submit"
						:loading="loading"
					>
						<v-icon dark>check</v-icon> {{$t('common.save') }}
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			dialog: false,
			form: {},
			valid: false,
			loading: false
		}
	},
	mounted () {
		this.$bus.$on('openDialogEditarRegistro', item => {
			this.form = item
			this.dialog = true
		})
	},
	methods: {
		close () {
			this.form = {},
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialog')
			this.dialog = false
		},
		async save () {
			if (this.$refs.form.validate()) {
				if (this.form.ingreso_am || this.form.salida_am || this.form.ingreso_pm || this.form.salida_pm) {
         
				this.loading = true
				let respuesta
				let correcto
				let resps
				const user = this.$storage.get("user");

			//guardar
			 try {

               respuesta = await this.$service.graphql({
                  query: `
                        query{
                          runQuery(consulta:"select control.fn_actualiza_asistencia_manual_detalle (${parseInt(this.form.id_detalle)},'${this.form.ingreso_am}','${this.form.salida_am}','${this.form.ingreso_pm}','${this.form.salida_pm}',${user.id_persona})"){
                                respuesta
                            }
                          }	
                        `
                });
                let respuesta2 = respuesta.runQuery.respuesta[0].fn_actualiza_asistencia_manual_detalle;
                    resps = respuesta2.split("|");
				
                    correcto = resps[0];
                
                        if (correcto == "1") {
                           this.$confirm("Modificación exitosa", () => {
                           this.close()
                            });
                    
                      }
                      else{
                        
                          this.$confirm(resps[1], () => {
                    
                            });
                      } 
            } catch (error) {
              console.log(error)
            }
				
				this.loading = false
				//this.close()
			}
			else{}
			}
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/dialogs/EditarRegistro.vue